import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <p className="text-5xl mb-4">🤷</p>
        <h1 className="font-display text-2xl font-extrabold text-red-700 mb-2">Không tìm thấy trang</h1>
        <p className="text-sm text-gray-500 mb-6">Trang bạn đang tìm không tồn tại.</p>
        <Link to="/dashboard" className="text-sm text-red-700 underline">
          Về trang chính
        </Link>
      </div>
    </div>
  );
}
